// Imports
import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { MockCard } from "@molecules"

export const ServiceCard = ({
  title,
  desc,
  image,
  small,
  mock,
  first,
  imageURL,
}) => {
  const img = getImage(image)

  if (!mock) {
    return (
      <div className={`service-card${small ? " small" : ""}`}>
        <div className="service-card__image">
          {small ? (
            <span>
              <img src={imageURL} alt={title} />
            </span>
          ) : (
            <GatsbyImage image={img} alt={title} />
          )}
        </div>
        <h5> {title} </h5>
        <p>{desc}</p>
      </div>
    )
  }
  if (mock) {
    return <MockCard className="service-card-mock" first={first} />
  }
}
